module.exports = __webpack_public_path__ + "static/img/product_society_society_xzzjyy.a2f5691.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_xzzjyy.png
// module id = ZMwL
// module chunks = 0